import markApplications from "./markApplications";

const markApplicationService = [{
    matcher: 'processingMarkApplication',
    reply: config => {
        return [200, markApplications];
    }
},{
    matcher: /processingMarkApplication\/(.*)/,
    reply: config => {
        const id = /processingMarkApplication\/(.*)/.exec(config.url)[1];
        const data = markApplications.find(app => app.id === id);
        return [200, data];
    }
}]

export default markApplicationService;